import React from 'react';
import './loading.scss'
import { withTranslation } from 'react-i18next';
import LogoLoader from '../../newStyledComponents/Loaders/LogoLoader';
import CustomModal from '../modals/CustomModal';

const Loading = ({ t }) => (

  <CustomModal
    customClass="confirmation-modal"
    show
    colorCloseIcon="#594da0"
    modalOptions={{
      backdropClassName: 'modal-backdrop--full-covered',
    }}
  >
    <div className="top p-4">
      <div className="row justify-content-center align-content-center h-100 ">
        <div className="col-12">
          <LogoLoader src="/assets/images/logo/finsave-app-icon.svg" size="xs" />
        </div>
      </div>
    </div>
    <div className="pink-ll-bg p-5 text-center">
      <h5>
        {t('loadingModal.title')}
      </h5>
      {t('loadingModal.body1')}
    </div>
  </CustomModal>

);

export default withTranslation()(Loading);
